import {Component, Input} from '@angular/core';
import {AccordionModule} from 'primeng/accordion';
import {NgClass, NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {environment} from "../../../../environments/environment";
import {EvidenceSvgPipe} from "../../../shared/pipes/evidence-svg.pipe";
import {Subscriptions} from "../../model/subscriptions.models";
import {Router, RouterLink} from "@angular/router";

@Component({
    selector: 'app-signature-standards',
    standalone: true,
    imports: [
        AccordionModule, NgClass, NgIf, TranslatePipe, EvidenceSvgPipe, RouterLink
    ],
    templateUrl: './signature-standards.component.html',
    styleUrl: './signature-standards.component.scss'
})
export class SignatureStandardsComponent {

    isFirstExpanded = false;
    isSecondExpanded = false;
    isThirdExpanded = false;
    isQesExpanded = false;
    whoChecked!: string;
    @Input() userSubscription!: Subscriptions;

    constructor(private router: Router,) {
    }

    ngOnInit() {
        this.whoChecked = environment.signatureCheckFirm;
    }

    openPaymentComponent() {
        this.router.navigate(['/payment'], {
            queryParams: {purchaseType: 'subscriptionPayment'}
        });
    }

    toggleStatus(element: number) {
        if (element === 1) {
            this.isFirstExpanded = !this.isFirstExpanded;
        }
        if (element === 2) {
            this.isSecondExpanded = !this.isSecondExpanded;
        }
        if (element === 3) {
            this.isThirdExpanded = !this.isThirdExpanded;
        }
        if (element === 4) {
            this.isQesExpanded = !this.isQesExpanded;
        }
    }
}
